<template>

　　<div>

　　　　<!--editor的div为富文本的承载容器-->

　　　　<div id="ueditor" type="text/plain"></div>

　　　　<button type="" @click="save">点击</button>

　　</div>

</template>
<script>
import '../../assets/Ueditor/ueditor.config.js'

import '../../assets/Ueditor/ueditor.all.min.js'

import '../../assets/Ueditor/lang/zh-cn/zh-cn.js'

import '../../assets/Ueditor/ueditor.parse.min.js'

export default {
  components: {
  },
  data() {
    return {
      ue: "",
    };
  },
  computed:{
    
  },
  methods: {
     gettext() {

　　　　　　// 获取editor中的文本

                　　console.log(this.editor.getContent())

        },
        save(){
	        let ueditordata = UE.getEditor('ueditor').getContent();
//	        Event.$emit('seted', ueditordata);
			console.log(ueditordata)
	      }
  },
  mounted() {
    this.ue = UE.getEditor('ueditor',{
        BaseUrl: '',
        UEDITOR_HOME_URL: 'static/utf8-jsp/',
     })
  }
};
</script>

<style>
@import url("../../assets/Ueditor/themes/default/css/ueditor.css");
</style>



// WEBPACK FOOTER //
// src/components/infoMana/test.vue